import PropTypes from 'prop-types'

import { Body, Header, Root } from './AppLayout.styles'

/**
 * The AppLayout component.
 */
const AppLayout = ({ children, header }) => {
  return (
    <Root direction="column" spacing={4}>
      {header && <Header>{header}</Header>}

      <Body direction="column" spacing={4}>
        {children}
      </Body>
    </Root>
  )
}

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node
}

export default AppLayout
